import React, { useState, useContext, useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import "../../../../stylesheet/forms.css";
import { addDocuments, editDocuments } from "../../../../Utils/localStore";
import ToastContext from "../../../../context/toasterContex";
import axios from "axios";

const NewDocument = ({ onClose, update, details, edit, docDetails }) => {
  const { toast } = useContext(ToastContext);
  const [documentData, setDocumentData] = useState({
    userLocalId: details.localID,
  });
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [image, setImage] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [cldDetails, setCldDetails] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadComplete, setUploadComplete] = useState(false);

  useEffect(() => {
    if (edit) {
      setDocumentData({ ...docDetails });
      if (docDetails.documentUrl) {
        setImage(docDetails.documentUrl);
      }
    }
  }, []);

  let today = Date.now();
  const formatter = new Intl.DateTimeFormat("en-NG", {
    dateStyle: "full",
    timeStyle: "long",
  });
  today = formatter.format(today);
  const handleFormUpdate = (e) => {
    const { id, value } = e.target;
    setDocumentData({
      ...documentData,
      date: today,
      [id]: value,
    });
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    setFileName(e.target.files[0].name);
    setFile(e.target.files[0]);
    setImage(URL.createObjectURL(e.target.files[0]));
  };
  const uploadImage = async () => {
    setUploading(true);
    const size = file.size;
    const chunkSize = 5 * 1024 * 1024;
    const totalChunks = Math.ceil(size / chunkSize);
    // Check file size and validate
    const formData = new FormData();
    formData.append("file", file);
    formData.append("cloud_name", window?.env?.CLOUDINARY_CLOUD_NAME);
    formData.append("upload_preset", window?.env?.CLOUDINARY_UPLOAD_PRESETS);
    formData.append("folder", "Pharmanager");
    const contentRange = `bytes ${totalChunks}/${chunkSize}`;
    let response;

    try {
      response = await axios.post(
        `https://api.cloudinary.com/v1_1/${window?.env.CLOUDINARY_CLOUD_NAME}/auto/upload`,
        formData
      );
      if (response) {
        setCldDetails(response.data);
        setUploaded(true);
        setUploading(false);
        setUploadComplete(true);
      }
    } catch (err) {
      toast.error("Please try upload again, something went wrong");
    } finally {
      return new Promise((resolve, reject) => {
        resolve(response);
      });
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let newDocument;
    if (!edit) {
      await uploadImage().then((resp) => {
        if (resp) {
          newDocument = {
            ...documentData,
            date: today,
            documentUrl: resp.data?.url,
          };
          addDocuments(newDocument)
            .then(() => {
              update();
              toast.success("Note Added successfully", {
                position: toast.POSITION.TOP_CENTER,
              });
            })
            .catch((err) => {
              toast.error("Something went wrong, please try again later", {
                position: toast.POSITION.TOP_CENTER,
              });
              throw new Error(err);
            });
        } else {
          toast.error("Please try upload again, something went wrong");
          // console.log("not proce....");
        }
      });
    } else {
      let image, newDocument;
      if (file) {
        image = await uploadImage().then((resp) => {
          newDocument = {
            ...documentData,
            date: today,
            documentUrl: resp.data?.url,
          };
        });
      } else if (!file && image) {
        newDocument = { ...documentData, date: today };
      } else {
        newDocument = { ...documentData, date: today };
      }
      console.log({ newDocument });
      await editDocuments(newDocument)
        .then(() => {
          toast.success("Note updated successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
        })
        .catch((err) => {
          // console.log({ err });
          toast.error("Something went wrong, please try again later", {
            position: toast.POSITION.TOP_CENTER,
          });
          throw new Error(err);
        });
    }
    onClose(e);
  };
  return (
    <>
      <dialog>
        <div className="w-full lg:w-[700px] bg-white rounded-md border">
          <section className="font-euclid-circular-a w-full">
            <div className="w-full bg-primary rounded-t-md sticky top-0">
              <div className="flex justify-between w-full align-middle">
                <h2 className="text-white text-xl font-semibold leading-7 tracking-wide p-8">
                  {!edit ? "Add Document" : "Edit Document"}
                </h2>
                <div className="leading-7 text-xl font-semibold  p-8">
                  <button onClick={onClose}>
                    {" "}
                    <RiCloseLine color="white" size={30} />{" "}
                  </button>
                </div>
              </div>
            </div>
          </section>
          <section className="font-euclid-circular-a w-full p-8">
            <form
              id="appt_form2"
              className="appt_form"
              onSubmit={(e) => handleFormSubmit(e)}
            >
              <label htmlFor="document_title">Title of Document</label>
              <input
                className="titleInput"
                type="text"
                id="title"
                required
                name="title"
                defaultValue={documentData?.title || ""}
                onChange={(e) => handleFormUpdate(e)}
                placeholder="Enter document title"
              />
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                required
                defaultValue={documentData?.description || ""}
                onChange={(e) => handleFormUpdate(e)}
                className="h-[118px]"
                placeholder="Enter a description..."
              />
              <label htmlFor="upload_file">Upload Document</label>

              {image ? (
                <>
                  <div className="w-full justify-between flex gap-2">
                    <div className="w-1/2">
                      <img src={image} className="w-[250px]" />
                      <div className="text-left flex gap-2 my-4">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            setImage(null);
                            setFileName("");
                          }}
                          className="p-2 border rounded-md border-red-400"
                          disabled={uploaded || uploading}
                        >
                          Change Image
                        </button>
                        {/* <button onClick={(e) => { e.preventDefault(); uploadImage(e) }} disabled={uploaded || uploading || uploadComplete} className="p-2 border rounded-md border-green-400">
                          Upload Image
                        </button> */}
                      </div>
                    </div>
                    <div className="w-1/2">
                      {/* <CircularProgressbar className="h-70"
                        value={75}
                        text="75%"
                        styles={buildStyles({
                          textSize: "2.25rem",
                          trailColor: "rgba(255, 255, 255, 0.19)",
                          backgroundColor: "rgba(255, 255, 255, 0.19)",
                          pathColor: "blue",
                          textColor: "blue",
                        })}
                      /> */}
                    </div>
                  </div>
                </>
              ) : (
                <div className="w-[640px] h-[52px] flex gap-6 bg-white rounded-lg border border-gray-200 items-center">
                  <label htmlFor="upload_file">
                    <div className="ml-2 border-2 rounded-2xl flex p-2 items-center mb-2 cursor-pointer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="11"
                        viewBox="0 0 11 11"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_368_4721)">
                          <path
                            d="M9.625 4.125V2.29167C9.625 2.04855 9.52842 1.81539 9.35651 1.64349C9.18461 1.47158 8.95145 1.375 8.70833 1.375H2.29167C2.04855 1.375 1.81539 1.47158 1.64349 1.64349C1.47158 1.81539 1.375 2.04855 1.375 2.29167V4.125"
                            stroke="black"
                            strokeOpacity="0.37"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3.20703 6.4165L5.4987 4.12484L7.79036 6.4165"
                            stroke="black"
                            strokeOpacity="0.37"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.5 4.125V9.625"
                            stroke="black"
                            strokeOpacity="0.37"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_368_4721">
                            <rect
                              width="11"
                              height="11"
                              fill="white"
                              transform="matrix(1 0 0 -1 0 11)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </label>
                  {fileName ? (
                    <p className="text-neutral-400 text-base font-semibold">
                      {fileName}
                    </p>
                  ) : (
                    <p className="text-neutral-900 text-base font-semibold">
                      Upload document here
                    </p>
                  )}

                  <div>
                    <input
                      type="file"
                      id="upload_file"
                      className="hidden"
                      name="file"
                      onChange={(e) => handleFileUpload(e)}
                    />
                  </div>
                </div>
              )}

              <div className="flex justify-end mt-3">
                <button className="document_button" type="submit">
                  Continue
                </button>
              </div>
            </form>
          </section>
        </div>
      </dialog>
    </>
  );
};

export default NewDocument;
